// extracted by mini-css-extract-plugin
module.exports = {"faq_question":"FaqCard_faq_question__2hei6","faq_answer":"FaqCard_faq_answer__3YVKD","question":"FaqCard_question__10L98"};